// extracted by mini-css-extract-plugin
module.exports = {"answer":"answer-box-module--answer--3TYK8","contents":"answer-box-module--contents--cCiSF","triangle":"answer-box-module--triangle--2ldja"};